import { Component, OnInit, OnDestroy } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';

const BODY_CLASS = 'checkin__landing__body';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, OnDestroy {
  private config: ConfigService;

  constructor() {
    this.config = InjectorService.get().get(ConfigService);

    this.config.locale.set(this.config.company.locale);
    this.config.checkin.loading = false;
  }

  public ngOnInit(): void {
    document.body.classList.add(BODY_CLASS);
  }

  public ngOnDestroy(): void {
    document.body.classList.remove(BODY_CLASS);
  }
}
